export const VIRTUAL_BACKGROUND_ENABLED = "virtualBackgroundEnabled"
